import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetClassesWithMostOpeningParams {
  sessionId: string;
  format: 'csv';
}

export const getClassesWithMostOpeningAPI = async (
  params: GetClassesWithMostOpeningParams,
) => {
  const response = await baseAPI.get<string>(
    '/dashboard/capacity/most-openings',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useGetClassesWithMostOpening = (
  params: GetClassesWithMostOpeningParams,
) => {
  return useQuery({
    queryKey: [KEYS.CLASSES_WITH_MOST_OPENING, params.sessionId],
    queryFn: () => getClassesWithMostOpeningAPI(params),
    enabled: !!params.sessionId,
  });
};
